import { useState } from "react";
import { navLinks } from "@/mocks/leakHome";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-red-100 bg-white/90 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-[1280px] items-center gap-4 px-4 md:px-6">
        <a href="#top" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-red-600 text-white">
            <i className="ri-fire-fill text-xl"></i>
          </span>
          <span className="text-xl font-black tracking-tight text-red-700">
            52<span className="text-stone-800">爆料</span>
          </span>
        </a>

        <nav className="ml-6 hidden items-center gap-1 md:flex">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="rounded-md px-3 py-2 text-sm font-medium text-stone-600 transition hover:bg-red-50 hover:text-red-700"
            >
              {l.name}
            </a>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2 md:gap-3">
          <div className="hidden items-center gap-2 rounded-full border border-stone-200 bg-stone-50 px-3 py-2 lg:flex">
            <i className="ri-search-line text-sm text-stone-400"></i>
            <input
              type="text"
              placeholder="搜瓜、搜投稿、搜话题"
              className="w-40 bg-transparent text-sm outline-none placeholder:text-stone-400"
            />
          </div>
          <a
            href="#entry"
            className="hidden whitespace-nowrap items-center gap-1.5 rounded-full bg-stone-800 px-4 py-2 text-sm font-semibold text-white transition hover:bg-stone-900 sm:flex"
          >
            <i className="ri-question-line text-[14px]"></i>
            投稿须知
          </a>
          <a
            href="#entry"
            className="flex whitespace-nowrap items-center gap-1.5 rounded-full bg-red-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-red-700"
          >
            <i className="ri-send-plane-fill text-[14px]"></i>
            我要上墙
          </a>
          <button
            aria-label="打开菜单"
            onClick={() => setOpen((o) => !o)}
            className="flex h-9 w-9 items-center justify-center rounded-lg border border-stone-200 md:hidden"
          >
            <i className="ri-menu-line text-lg text-stone-700"></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-stone-100 bg-white px-4 py-3 md:hidden">
          <div className="mb-3 flex items-center gap-2 rounded-full border border-stone-200 bg-stone-50 px-3 py-2">
            <i className="ri-search-line text-sm text-stone-400"></i>
            <input
              type="text"
              placeholder="搜瓜、搜投稿、搜话题"
              className="w-full bg-transparent text-sm outline-none placeholder:text-stone-400"
            />
          </div>
          <nav className="grid grid-cols-2 gap-2">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg bg-stone-50 px-3 py-2.5 text-sm font-medium text-stone-700"
              >
                {l.name}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}